import instrumentsDataJson from '@shared-json/instruments.json';
import { InstrumentData } from '@shared-data';

export const instrumentsData = JSON.parse(JSON.stringify(instrumentsDataJson)) as InstrumentData;

export enum PerformanceSkillType {
  Accordion = 'Accordion',
  AcousticGuitar = 'Acoustic Guitar',
  Bagpipes = 'Bagpipes',
  Banjo = 'Banjo',
  BassGuitar = 'Bass Guitar',
  Bassoon = 'Bassoon',
  Bugle = 'Bugle',
  Cello = 'Cello',
  Clarinet = 'Clarinet',
  Clavichord = 'Clavichord',
  Cornet = 'Cornet',
  Cymbal = 'Cymbal',
  DJ = 'DJ',
  DoubleBass = 'Double Bass',
  Drums = 'Drums',
  ElectricGuitar = 'Electric Guitar',
  EnglishHorn = 'English Horn',
  Euphonium = 'Euphonium',
  Flugelhorn = 'Flugelhorn',
  Flute = 'Flute',
  FrenchHorn = 'French Horn',
  GrandPiano = 'Grand Piano',
  Harmonica = 'Harmonica',
  Harp = 'Harp',
  Harpsichord = 'Harpsichord',
  Keyboard = 'Keyboard',
  Mandolin = 'Mandolin',
  Maracas = 'Maracas',
  Mellophone = 'Mellophone',
  Oboe = 'Oboe',
  Organ = 'Organ',
  Piano = 'Piano',
  Piccolo = 'Piccolo',
  Saxophone = 'Saxophone',
  SteelDrums = 'Steel Drums',
  Tambourine = 'Tambourine',
  Timpani = 'Timpani',
  Triangle = 'Triangle',
  Trombone = 'Trombone',
  Trumpet = 'Trumpet',
  Tuba = 'Tuba',
  Ukulele = 'Ukulele',
  Viola = 'Viola',
  Violin = 'Violin',
  Vocals = 'Vocals',
  Xylophone = 'Xylophone',
}

export enum PerformanceSkillFamily {
  Brass = 'Brass',
  Keyboard = 'Keyboard',
  Other = 'Other',
  Percussion = 'Percussion',
  String = 'String',
  Voice = 'Voice',
  Woodwind = 'Woodwind',
}
